import * as THREE from 'three';

/**
 * 背景纸面（v2 spec §1：去颗粒）：纯米色，不加噪点和纤维。保留为纹理是为了不改动各场景的材质结构
 * （它们按视口设置 repeat），平涂色平铺后完全均匀。
 */
export function createPaperTexture(size = 16): THREE.CanvasTexture {
  const c = document.createElement('canvas');
  c.width = c.height = size;
  const g = c.getContext('2d')!;
  g.fillStyle = '#f3ecdc';
  g.fillRect(0, 0, size, size);
  const tex = new THREE.CanvasTexture(c);
  tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
  tex.colorSpace = THREE.SRGBColorSpace;
  return tex;
}

/** 柔和投影（用于棋盘底板下方） */
export function createShadowTexture(size = 256): THREE.CanvasTexture {
  const c = document.createElement('canvas');
  c.width = c.height = size;
  const g = c.getContext('2d')!;
  const pad = size * 0.18;
  g.shadowColor = 'rgba(70,50,20,0.45)';
  g.shadowBlur = size * 0.08;
  g.fillStyle = 'rgba(70,50,20,0.45)';
  g.fillRect(pad, pad, size - pad * 2, size - pad * 2);
  const tex = new THREE.CanvasTexture(c);
  tex.colorSpace = THREE.SRGBColorSpace;
  return tex;
}
